import React from 'react'
import { Edit } from 'react-admin'
import Form from './form'
import { editOptions } from '../../util/component-options'

const TonnageTicketUploadsEdit = props => {
  return (
    <Edit {...editOptions} {...props} >
      <Form isUpdateDisabled />
    </Edit>
  )
}

export default TonnageTicketUploadsEdit
